import React from 'react';
import { fmt } from '../utils/api';

export default function SafeToSpendHero({ safeToSpend, upcomingBills }) {
  if (safeToSpend == null) return null;

  let status = 'safe';
  if (safeToSpend <= 0) status = 'notSafe';
  else if (upcomingBills?.length > 0) status = 'tight';

  const config = {
    safe: {
      color: '#00d4aa',
      bg: 'linear-gradient(135deg, rgba(0,212,170,0.14), rgba(0,212,170,0.04))',
      border: '#00d4aa',
      glow: '0 0 30px rgba(0,212,170,0.25)',
      icon: '✓',
      label: 'Safe to Spend',
    },
    tight: {
      color: '#fbbf24',
      bg: 'linear-gradient(135deg, rgba(251,191,36,0.14), rgba(251,191,36,0.04))',
      border: '#fbbf24',
      glow: '0 0 30px rgba(251,191,36,0.25)',
      icon: '⚠',
      label: 'Tight - Bill Coming Up',
    },
    notSafe: {
      color: '#ef4444',
      bg: 'linear-gradient(135deg, rgba(239,68,68,0.18), rgba(239,68,68,0.05))',
      border: '#ef4444',
      glow: '0 0 40px rgba(239,68,68,0.35)',
      icon: '✗',
      label: 'Not Safe to Spend More',
    },
  };
  const c = config[status];

  return (
    <div
      style={{
        ...styles.hero,
        background: c.bg,
        borderColor: c.border,
        boxShadow: c.glow,
      }}
      className={status === 'notSafe' ? 'safe-to-spend-pulse' : undefined}
    >
      <div style={styles.left}>
        <div style={{ ...styles.iconCircle, borderColor: c.color, color: c.color }}>{c.icon}</div>
        <div>
          <div style={{ ...styles.label, color: c.color }}>{c.label}</div>
          {upcomingBills?.length > 0 && (
            <div style={styles.sub}>
              accounts for {upcomingBills.length} bill{upcomingBills.length !== 1 ? 's' : ''} due this week
            </div>
          )}
        </div>
      </div>
      {upcomingBills?.length > 0 && (
        <div style={styles.billsList}>
          {upcomingBills.map((b, i) => (
            <span key={i} style={styles.billTag}>{b.name} {fmt.currency(b.amount)}</span>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  hero: {
    border: '2px solid',
    borderRadius: '16px',
    padding: '0.9rem 1.25rem',
    marginBottom: '1.25rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.75rem',
  },
  left: { display: 'flex', alignItems: 'center', gap: '0.75rem' },
  iconCircle: {
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    border: '2px solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.05rem',
    fontWeight: '800',
    flexShrink: 0,
  },
  label: {
    fontSize: '0.92rem',
    fontWeight: '800',
    fontFamily: "'Syne', sans-serif",
    letterSpacing: '0.02em',
  },
  sub: {
    color: '#9ca3af',
    fontSize: '0.72rem',
    fontFamily: "'Syne', sans-serif",
    marginTop: '1px',
  },
  billsList: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: '6px',
  },
  billTag: {
    background: 'rgba(10,15,30,0.6)',
    border: '1px solid rgba(255,255,255,0.1)',
    color: '#e5e7eb',
    fontSize: '0.68rem',
    fontFamily: "'DM Mono', monospace",
    padding: '3px 10px',
    borderRadius: '999px',
  },
};
